export interface TokenPayload {
  sub?: string;
  iss?: string;
  scope?: string | string[];
  organization_id?: string;
  realm_id?: string;
  kw_pinned_realm?: string;
  exp?: number;
  [key: string]: unknown;
}

export function decodeJwtPayload(token: string): TokenPayload | null {
  try {
    const parts = token.split(".");
    if (parts.length !== 3) return null;
    const b64 = parts[1].replace(/-/g, "+").replace(/_/g, "/");
    const padded = b64 + "=".repeat((4 - (b64.length % 4)) % 4);
    const json = atob(padded);
    return JSON.parse(json) as TokenPayload;
  } catch {
    return null;
  }
}

export function extractScopes(token: string): string[] {
  const payload = decodeJwtPayload(token);
  if (!payload) return [];
  const raw = payload.scope;
  if (typeof raw === "string") {
    return raw.split(/\s+/).filter(Boolean);
  }
  if (Array.isArray(raw)) {
    return raw.filter((s): s is string => typeof s === "string");
  }
  return [];
}

export function hasScope(token: string | null, scope: string): boolean {
  if (!token) return false;
  return extractScopes(token).includes(scope);
}

export function hasAnyScope(token: string | null, scopes: string[]): boolean {
  if (!token) return false;
  const user = extractScopes(token);
  return scopes.some((s) => user.includes(s));
}
